// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"d48b8a61","154":"fcc0c42c","261":"d1cfb782","528":"e6616a8b","662":"b1b097e8","798":"e4125617","963":"3612e4d1"}[chunkId] + ".chunk.js";
};